import React from 'react';
import { motion } from 'framer-motion';
export function PrivacyPolicy() {
  const sections = [{
    title: 'Information We Collect',
    content: 'We collect information you provide directly to us, including your name, email address, shipping address, phone number, and payment information when you make a purchase or create an account. We also automatically collect certain information about your device and browsing activity.'
  }, {
    title: 'How We Use Your Information',
    content: 'Your information is used to process and fulfill orders, provide customer service, send you marketing communications (with your consent), improve our products and services, and comply with legal obligations. We never sell your personal data to third parties.'
  }, {
    title: 'Sharing of Information',
    content: 'We may share your information with trusted partners who assist us in operating our business, such as payment processors, shipping carriers, and email service providers. These partners are obligated to protect your information and use it only for the services they provide to us.'
  }, {
    title: 'Cookies & Tracking',
    content: 'We use cookies and similar technologies to enhance your browsing experience, analyze site traffic, and personalize content. You can control cookie preferences through your browser settings, though disabling cookies may affect site functionality.'
  }, {
    title: 'Your Rights',
    content: 'You have the right to access, correct, or delete your personal information at any time. You may also opt out of marketing communications by clicking the unsubscribe link in our emails or by contacting us directly.'
  }, {
    title: 'Data Security',
    content: 'We implement industry-standard security measures to protect your personal information from unauthorized access, alteration, or disclosure. All payment transactions are encrypted using SSL technology.'
  }, {
    title: 'Contact Us',
    content: 'If you have any questions about this Privacy Policy or our data practices, please contact us at our Alexandria studio or by phone at (571) 842-3307.'
  }];
  return <div className="bg-white min-h-screen pt-32 pb-20 px-6" data-id="element-759">
      <div className="max-w-3xl mx-auto" data-id="element-760">
        <motion.header initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="mb-20 text-center" data-id="element-761">
          <span className="text-xs md:text-sm font-display font-bold uppercase tracking-[0.3em] md:tracking-[0.5em] mb-6 block text-black/40" data-id="element-762">
            Legal
          </span>
          <h1 className="text-xl sm:text-4xl md:text-6xl font-display font-bold tracking-[0.05em] md:tracking-[0.2em] uppercase mb-6" data-id="element-763">
            Privacy Policy
          </h1>
          <p className="text-xs md:text-sm font-display font-bold tracking-widest text-black/40 uppercase" data-id="element-764">
            Last Updated: January 2024
          </p>
        </motion.header>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.2
      }} className="mb-16 p-8 bg-black/5 border-l-4 border-black" data-id="element-765">
          <p className="text-sm md:text-base font-normal leading-relaxed tracking-wide" data-id="element-766">
            At Djily Creations, we value your privacy and are committed to
            protecting your personal information. This policy outlines how we
            collect, use, and safeguard your data when you visit our site or
            engage with our services.
          </p>
        </motion.div>

        <div className="space-y-16" data-id="element-767">
          {sections.map((section, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="border-l-2 border-black pl-8" data-id="element-768">
              <div className="flex items-baseline space-x-4 mb-4" data-id="element-769">
                <span className="text-xs md:text-sm font-display font-bold tracking-widest text-black/30" data-id="element-770">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <h2 className="text-xl sm:text-2xl md:text-4xl font-display font-bold tracking-widest uppercase" data-id="element-771">
                  {section.title}
                </h2>
              </div>
              <p className="text-sm md:text-base font-normal text-black/70 leading-relaxed tracking-wide" data-id="element-772">
                {section.content}
              </p>
            </motion.div>)}
        </div>
      </div>
    </div>;
}